import ENV from "config";
import React from "react";
import { CSS_THEMES } from "../helpers/cssThemesImportHelper";
// create css theme components using React.lazy
const DefaultTheme = React.lazy(() => import("../themes/default/default"));
const WhiteLabelTheme = React.lazy(
  () => import("../themes/whitelabel/whitelabel")
);
const Evo = React.lazy(() => import("../themes/evo/evo"));
const GalaxyBet = React.lazy(() => import("../themes/galaxybet/galaxybet"));

// create a parent component that will load the css theme components conditionally using React.Suspense
const ThemeSelector = ({ children }) => {
  const CHOSEN_THEME = ENV.CSS_THEME;
  return (
    <>
      <React.Suspense fallback={<></>}>
        {CHOSEN_THEME === CSS_THEMES.DEFAULT && <DefaultTheme />}
        {CHOSEN_THEME === CSS_THEMES.WHITELABEL && <WhiteLabelTheme />}
        {CHOSEN_THEME === CSS_THEMES.EVO && <Evo />}
        {CHOSEN_THEME === CSS_THEMES.GALAXYBET && <GalaxyBet />}
      </React.Suspense>
      {children}
    </>
  );
};

export default ThemeSelector;
